import React from "react";

import { CartListItem } from "../CartListItem";
import { PRODUCT_TYPES } from "../../../../api/products/productBaseConstants";


export const CartTeaProductList = ({ tea }) => {
  return (
    <>
      {tea.valueSeq().map(teaItem => (
        <CartListItem key={`drink_${teaItem.get('id')}`}
                      item={teaItem}
					  type={PRODUCT_TYPES.warmer.id}
					  subtype={PRODUCT_TYPES.warmer.subtypes.tea.id}
                      imageType="alt"
					/>
				))}
		</>
	)
};
